<shortcut-menu [subscription]="subscription()">
  <malfunction-item [subscription]="subscription()" [messages]="activities()" />
  <availability-item [subscription]="subscription()" />
  <self-service-item [dirty]="dirty()" />
  <availability-export-item [subscription]="subscription()" />
  <send-config-item [subscriptionId]="subscription().subscriptionId" />
  <service-documentation-item [url]="serviceDocumentationUrl" />
</shortcut-menu>
